import { message, Modal } from "antd";
import { useTranslation } from "react-i18next";
import { EntReservoir } from "../../../models/reservoir";
import { useAddReservoirMutation, useDeleteReservoirMutation, useEditReservoirMutation } from "../../../redux/api/reservoir/reservoirApi";
import { getCookie } from "typescript-cookie";



const useReservoirs = (modal: any, refresh?: () => void) => {
    const { t } = useTranslation()
    const { confirm } = modal;
    const [addReservoir] = useAddReservoirMutation();
    const [deleteReservoir] = useDeleteReservoirMutation();
    const [editReservoir] = useEditReservoirMutation();

    async function onAddReservoir(newReservoir: EntReservoir): Promise<boolean> {
        try {
            let status: boolean = false;
            await addReservoir(newReservoir).then((response: any) => {
                if (response.error !== undefined) {
                    const errorMessage = response.error.data.res
                .map((error: any) => `${error.kg} / ${error.ru} `)
                .join('\n');
            throw new Error(errorMessage);
                }
                if (response.data.success) {
                    status = true;
                    message.success(t('msg.successAdd'));
                    if (refresh) refresh();
                }
            }).catch((error: any) => {
                modal.error({ title: t('msg.error'), content: String(error.message) });

            });
            return status;
        } catch (error: any) {
            modal.error({ title: t('msg.error'), content: String(error.message) });
            return false;
        }
    }


    async function onDeleteReservoir(reservoirs: EntReservoir) {
        try {
            let status: boolean = false;
            confirm({
                centered: true,
                title: t('msg.confirmDeleteText'),
                okText: t('general.yes'),
                cancelText: t('general.no'),
                onOk() {
                    deleteReservoir(reservoirs.id).then((response: any) => {
                        if (response.error) {
                            const isKyrgyz = getCookie('i18next') === 'ky';
                            const lang = isKyrgyz ? 'kg' : 'ru';
                            const res = response.error.data?.res;
                            const errorMessages = Array.isArray(res)
                                ? res.map((error: any) => error[lang] || error.ru).join('\n')
                                : response.error.data?.msg || t('unknownError'); 
                            throw new Error(errorMessages);
                        }
                        if (response.data.success) {
                            status = true;
                            Modal.success({ title: t('msg.successDelete') });
                            if (refresh) refresh();
                        }
                    }).catch((error: any) => {
                        Modal.error({ title: t('msg.error'), content: String(error.message) });

                    });
                }
            })
            return status
        } catch (error: any) {
            Modal.error({ title: t("msg.error"), content: String(error.message) });
            return false;
        }
    };
    async function onEditReservoir(editedReservoir: EntReservoir): Promise<boolean> {
        try {
            let status: boolean = false;
            await editReservoir(editedReservoir).then((response: any) => {
                 if (response.error) {
                                             const isKyrgyz = getCookie('i18next') === 'ky';
                                             const lang = isKyrgyz ? 'kg' : 'ru';
                                             const res = response.error.data?.res;
                                             const errorMessages = Array.isArray(res)
                                                 ? res.map((error: any) => error[lang] || error.ru).join('\n')
                                                 : response.error.data?.msg || t('unknownError'); 
                                             throw new Error(errorMessages);
                                         }
                if (response.data.success) {
                    status = true;
                    Modal.success({ title: t('msg.successEdited') });
                    if (refresh) refresh();
                }
            }).catch((error: any) => {
                Modal.error({ title: t('msg.error'), content: String(error.message) });
            });
            return status;
        } catch (error: any) {
            Modal.error({ title: t("msg.error"), content: String(error.message) });
            return false;
        }
    };
    return { onAddReservoir, onDeleteReservoir, onEditReservoir }

}
export { useReservoirs };

